import { render, staticRenderFns } from "./ViewFuneralNotice.vue?vue&type=template&id=52670447&scoped=true&"
import script from "./ViewFuneralNotice.vue?vue&type=script&lang=js&"
export * from "./ViewFuneralNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52670447",
  null
  
)

export default component.exports